export default __webpack_public_path__ + "static/media/accredited-provider-badge.8649f3ed.svg";